var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdcInfoSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1878_208)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.4272 45.5303L36.2581 33.3612C43.3967 24.6305 42.106 11.7659 33.3753 4.62735C24.6446 -2.51114 11.7801 -1.22068 4.64152 7.51003C-2.49708 16.2407 -1.20642 29.1053 7.52429 36.2439C15.0444 42.3928 25.8553 42.3928 33.3754 36.2439L45.5445 48.4131C46.3545 49.1952 47.6451 49.1729 48.4273 48.3629C49.1903 47.5729 49.1903 46.3203 48.4272 45.5303ZM4.17257 20.4682C4.17257 11.4606 11.4747 4.15841 20.4824 4.15841C29.4901 4.15841 36.7922 11.4606 36.7922 20.4682C36.7922 29.4759 29.4901 36.7781 20.4824 36.7781C11.4789 36.7679 4.18272 29.4717 4.17257 20.4682ZM24.5599 12.3133C23.0369 12.3202 21.5756 12.9163 20.4825 13.9769C19.3894 12.9164 17.9281 12.3202 16.4051 12.3133C12.9183 12.434 10.1846 15.3499 10.2889 18.8372C10.2889 22.9146 14.4499 27.1206 17.9422 29.9278C19.4288 31.1118 21.5362 31.1118 23.0227 29.9278C26.515 27.1205 30.6761 22.9146 30.6761 18.8372C30.7802 15.3499 28.0467 12.434 24.5599 12.3133ZM20.4946 26.7475C16.7148 23.7098 14.3662 20.6721 14.3662 18.8373C14.2645 17.6021 15.1716 16.5134 16.405 16.3908C17.6382 16.5134 18.5455 17.6021 18.4437 18.8373C18.4437 19.9632 19.3564 20.876 20.4825 20.876C21.6084 20.876 22.5212 19.9633 22.5212 18.8373C22.4195 17.6021 23.3267 16.5134 24.56 16.3908C25.7932 16.5134 26.7005 17.6021 26.5988 18.8373C26.5986 20.6721 24.25 23.7098 20.4946 26.7475Z",
    fill: "#1D1C1C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1878_208"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 49,
    height: 49,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdcInfoSearch);
export default __webpack_public_path__ + "static/media/edc-info-search.f88d036ca700dc956bce2548020c81f5.svg";
export { ForwardRef as ReactComponent };